"use client";

import React from "react";

export default function ShippingPolicy() {
  return (
    <main className="min-h-screen bg-white">
      {/* HEADER SECTION */}
      <div className="bg-[#fafafa] pt-32 pb-20 px-6 border-b border-neutral-100">
        <div className="max-w-[800px] mx-auto text-center">
          <h1 className="text-4xl md:text-5xl font-serif italic text-[#121826]">
            Shipping Policy
          </h1>
          <div className="w-16 h-[1.5px] bg-[#c8a96e] mx-auto mt-6"></div>
        </div>
      </div>

      {/* CONTENT SECTION */}
      <section className="max-w-[800px] mx-auto py-16 px-6 md:py-24">
        <div className="space-y-12 text-[#444] leading-[1.8] font-light">
          
          <p className="text-lg text-[#121826] font-medium italic">
            At Modish Kreations, we are committed to ensuring timely and efficient delivery of your bespoke orders. Please review our shipping guidelines below.
          </p>

          {/* DOMESTIC SHIPPING */}
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#121826] flex items-center gap-3">
              <span className="w-6 h-[1px] bg-[#c8a96e]"></span>
              Domestic Shipping (Within India)
            </h2>
            <div className="pl-9 space-y-4">
              <ul className="list-disc pl-5 space-y-2 marker:text-[#c8a96e]">
                <li><strong>FREE Shipping:</strong> Enjoy complimentary shipping across India on all orders above ₹500.</li>
                <li><strong>Dispatch Timeline:</strong> Orders are typically dispatched within 1–3 working days.</li>
              </ul>

              {/* TIMELINE BOX */}
              <div className="bg-[#fcfaf7] p-6 rounded-2xl border border-[#f0ede8] space-y-3">
                <p className="font-bold text-[#121826] text-sm uppercase tracking-widest">Order Processing Timeline</p>
                <p className="text-sm">Orders placed before <strong>1:00 PM</strong> are generally dispatched the same day, subject to payment confirmation and product availability.</p>
                <p className="text-sm">Orders placed after 1:00 PM, on Sundays, or public holidays will be processed on the next working day.</p>
              </div>
            </div>
          </div>

          {/* INTERNATIONAL SHIPPING */}
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#121826] flex items-center gap-3">
              <span className="w-6 h-[1px] bg-[#c8a96e]"></span>
              International Shipping
            </h2>
            <div className="pl-9 space-y-4">
              <p>We deliver globally with a typical timeline of <strong>5–7 business days</strong> from dispatch.</p>
              
              <div className="space-y-3 bg-neutral-50 p-5 rounded-xl text-sm">
                <p className="font-semibold text-[#121826]">Customs, Duties & Taxes:</p>
                <ul className="list-disc pl-5 space-y-2">
                  <li>Import duties or VAT are <strong>not included</strong> in the product or shipping cost.</li>
                  <li>These are payable directly by the customer to the courier at the time of delivery.</li>
                  <li>Charges are governed by local regulations; Modish Kreations cannot predict these amounts.</li>
                </ul>
              </div>
            </div>
          </div>

          {/* GENERAL TERMS */}
          <div className="space-y-4">
            <h2 className="text-xl font-bold text-[#121826] flex items-center gap-3">
              <span className="w-6 h-[1px] bg-[#c8a96e]"></span>
              General Shipping Terms
            </h2>
            <div className="pl-9 space-y-3 text-sm italic text-neutral-500">
              <p>• Delivery timelines are indicative and may vary due to logistics, weather, or customs clearance.</p>
              <p>• Delays beyond our control will not be eligible for refunds, returns, or exchanges.</p>
            </div>
          </div>

          {/* FINAL NOTE */}
          <div className="pt-10 border-t border-neutral-100 text-center">
            <div className="inline-block px-8 py-3 border border-[#c8a96e] text-[#c8a96e] text-[11px] font-bold uppercase tracking-[0.2em] rounded-sm">
              Reliable Delivery Experience
            </div>
            <p className="mt-6 text-sm text-neutral-400 max-w-[600px] mx-auto italic">
              At Modish Kreations, we strive for transparency at every step of your garment's journey to your doorstep.
            </p>
          </div>

        </div>
      </section>
    </main>
  );
}